import { persist } from 'zustand/middleware';
import { create } from 'zustand';

interface SettingsState {
  setHideIngameChat: (hideIngameChat: boolean) => void,
  setSeenPatchnotes: (seenPatchnotes: number) => void,
  setShowBanner: (showBanner: boolean) => void,
  setShowRate: (showRate: boolean) => void,
  setMuted: (muted: boolean) => void,
  hideIngameChat: boolean,
  seenPatchnotes: number,
  showBanner: boolean,
  showRate: boolean,
  muted: boolean,
}

export const useSettingsStore = create<SettingsState>()(
  persist(
    (set) => ({
      setHideIngameChat: (hideIngameChat) => set({ hideIngameChat }),
      setSeenPatchnotes: (seenPatchnotes) => set({ seenPatchnotes }),
      setShowBanner: (showBanner) => set({ showBanner }),
      setShowRate: (showRate) => set({ showRate }),
      setMuted: (muted) => set({ muted }),
      hideIngameChat: false,
      seenPatchnotes: -1,
      showBanner: true,
      showRate: true,
      muted: false,
    }),
    { name: 'settings-storage' },
  ),
);